const status = {
	incomplete: 'Incomplete (Not Released)',
	waitlist: 'Wait List',
	new: 'New',
	open: 'Open',
	onhold: 'On Hold',
	completed: 'Service Provided',
	closed: 'Service Not Provided',
	cancelled: 'Cancelled',
	fulfillment: 'Open: In-fulfillment',
	'closed-no-contact': 'Service Not Provided: Unable to Contact Client',
	'closed-duplicate': 'Service Not Provided: Duplicate Service Request',
	'closed-service-not-available':
		'Service Not Provided: Service not currently available',
	'closed-registration':
		'Service Not Provided: Registration full/past deadline',
	'closed-ineligible': 'Service Not Provided: Client ineligible',
	'closed-service-inaccessible': 'Service Not Provided: Service inaccessible',
	'closed-opted-out': 'Service Not Provided: Client opted out',
	'closed-other': 'Service Not Provided: Other',
	'closed-verbal': 'Verbal Referral Made',
};
export default {
	status,
	closedStatuses: [
		'completed',
		'cancelled',
		...Object.keys(status).filter((s) => s.startsWith('closed')),
		'closed-verbal',
	],
	shortStatus: {
		completed: 'Complete',
		closed: 'Close',
		cancelled: 'Cancel',
	},
	durationUnits: {
		once: 'Once',
		days: 'Daily',
		weeks: 'Weekly',
		months: 'Monthly',
		yearly: 'Yearly',
	},
	marital_status: {
		single: 'Single',
		married: 'Married',
		divorced: 'Divorced',
		widowed: 'Widowed',
	},
	disability: {
		no: 'No',
		yes: 'Yes',
		decline: 'Decline to answer',
	},
	veteran: {
		no: 'No',
		yes: 'Yes',
		decline: 'Decline to answer',
	},
	ethnicity: {
		no: 'Not Hispanic or Latino',
		yes: 'Hispanic or Latino',
		decline: 'Decline to answer',
	},
	race: {
		amer_indian: 'American Indian or Alaska Native',
		asian: 'Asian',
		black: 'Black or African American',
		native_hawaiian_islander: 'Native Hawaiian or Other Pacific Islander',
		white: 'White',
		other: 'Other race',
		decline: 'Decline to answer',
	},
	fulfillmentStatus: {
		FULFILLED: 'Fulfilled',
		NOT_REIMBURSEABLE: 'Fulfilled - Not Reimbursable',
		NOT_ELIGIBLE: 'Not Eligible',
	},
	agencyType: {
		CLINICAL: 'clinical',
		EXECUTING: 'executing',
		HEALTHPLAN: 'healthplan',
	},
};
